import React from "react"
import Waypoint from "react-waypoint";
import AnimateEffect from "../../tool/animateEffect";
import feature_1 from "../../../images/intro/1.jpg";
import feature_2 from "../../../images/intro/2.jpg";
import feature_3 from "../../../images/intro/3.jpg";
import feature_4 from "../../../images/intro/4.jpg";
import { strings, _ } from "../../strings"


export class PrivacyPolicyContent extends React.Component {
	constructor(props) {
    console.log("Index constructor")
    super(props);
    console.log(props, _("privacy_policy_title"))
    this.state = {
      serviceWaypoint: true,
      navFix: true,
    };
  }
	render() {
		const {
      serviceWaypoint,
      navFix
    } = this.state;
		return (
			<section className="section-privacy-policy">
				<section className="section-2 vertical-flex-item" id="serviceSection">
					<div className="service-container policy-container" lang="en">
						<div className="title-group">
							<div className="sub-title">{_("privacy_policy_version")}</div>
						</div>
					<div className="service-features policy-content">
						<div className="policy-content policy-content-main">
							<p>{_("privacy_policy_content_1")}</p>
						</div>
						<AnimateEffect trigger={serviceWaypoint} className={"feature"} effect={"fadeInUp"} delay={800} >
							<div className="feature-image"><img src={feature_1}/><div className="overlay"/></div>
							<div className="feature-content">
								<div className="feature-content-title">{_("privacy_policy_content_2_1")}</div>
								<div className="feature-content-text">
									<p>{_("privacy_policy_content_2_2_1")}</p>
									<ul>
										<li>{_("privacy_policy_content_2_2_2_1")}</li>
										<li>{_("privacy_policy_content_2_2_2_2")}</li>
										<li>{_("privacy_policy_content_2_2_2_3")}</li>
										<li>{_("privacy_policy_content_2_2_2_4")}</li>
									</ul>
								</div>
							</div>
						</AnimateEffect>
						<AnimateEffect trigger={serviceWaypoint} className={"feature"} effect={"fadeInUp"} delay={600} >
							<div className="feature-image"><img src={feature_2}/><div className="overlay"/></div>
							<div className="feature-content">
								<div className="feature-content-title">{_("privacy_policy_content_3_1")}</div>
								<div className="feature-content-text">
									<p>{_("privacy_policy_content_3_2_1")}</p>
									<ul>
										<li>{_("privacy_policy_content_3_2_2_1")}</li>
										<li>{_("privacy_policy_content_3_2_2_2")}</li>
										<li>{_("privacy_policy_content_3_2_2_3")}</li>
										<li>{_("privacy_policy_content_3_2_2_4_1")}</li>
											<ul>
												<li>{_("privacy_policy_content_3_2_2_4_2_1")}</li>
												<li>{_("privacy_policy_content_3_2_2_4_2_2")}</li>
												<li>{_("privacy_policy_content_3_2_2_4_2_3")}</li>
											</ul>
										<li>{_("privacy_policy_content_3_2_2_5")}</li>
										<li>{_("privacy_policy_content_3_2_2_6")}</li>
									</ul>
								</div>
							</div>
						</AnimateEffect>
						<AnimateEffect trigger={serviceWaypoint} className={"feature"} effect={"fadeInUp"} delay={700} >
							<div className="feature-image"><img src={feature_3}/><div className="overlay"/></div>
							<div className="feature-content">
								<div className="feature-content-title">{_("privacy_policy_content_4_1")}</div>
								<div className="feature-content-text">
									<p>{_("privacy_policy_content_4_2")}</p>
								</div>
							</div>
						</AnimateEffect>
						<AnimateEffect trigger={serviceWaypoint} className={"feature"} effect={"fadeInUp"} delay={900} >
							<div className="feature-image"><img src={feature_4}/><div className="overlay"/></div>
							<div className="feature-content">
								<div className="feature-content-title">{_("privacy_policy_content_5_1")}</div>
								<div className="feature-content-text">
									<p>{_("privacy_policy_content_5_2")}</p>
								</div>
							</div>
						</AnimateEffect>
					</div>
				</div>
			</section>
			</section>
			)
	}
}
